export default __webpack_public_path__ + "static/schody-82991c257d74937d3c72d36eb6cbd229.jpg";